import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card, Typography, Spin, Button, message } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import axios from '../../../config/axiosInstance';
import API_BASE_URL from '../../../config/api';
import { Helmet } from 'react-helmet-async';

const { Title, Paragraph } = Typography;

const NewsDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [news, setNews] = useState(null);

  const fetchNews = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/news/${id}`);
      setNews(res.data);
    } catch {
      message.error('โหลดข่าวล้มเหลว');
    }
  };


  useEffect(() => {
    fetchNews();

  }, [id]);

  useEffect(() => {
    document.title = `${news?.title} | สำนักงานเจ้าคณะภาค 4-5 (ธรรมยุต)`;
  }, [news]);

  useEffect(() => {
    const images = document.querySelectorAll('.ql-editor img');
    images.forEach((img) => {
      img.style.maxWidth = '50%';
      img.style.height = 'auto';
      img.style.display = 'block';
      img.style.margin = '1rem auto';
    });
  }, [id]);

  if (!news) return <Spin tip="กำลังโหลด..." />;

  return (
    <div>
      {news && (
        <>
          <Helmet>
            <title>{news.title} | สำนักงานเจ้าคณะภาค 4-5 (ธรรมยุต)</title>
            <meta name="description" content="ระบบสารสนเทศคณะสงฆ์ ภาค 4-5 (ธรรมยุต)" />
            <meta property="og:title" content={`${news.title} | สำนักงานเจ้าคณะภาค 4-5 (ธรรมยุต)`} />
            <meta property="og:description" content="ระบบสารสนเทศคณะสงฆ์ ภาค 4-5 (ธรรมยุต)" />
            <meta property="og:image" content={news.cover_image} />
            <meta property="og:url" content="https://example.com/" />
            <link rel="canonical" href="https://example.com/" />
          </Helmet>

          <main>
            <h1>{news.title}</h1>
            <Button type="link" icon={<ArrowLeftOutlined />} onClick={() => navigate(-1)}>
              ย้อนกลับ
            </Button>

            <Card
              cover={<img alt={news.title} src={news.cover_image} style={{ objectFit: 'cover', maxHeight: 450 }} />}
            >
              <div
                className="ql-editor"
                style={{ fontFamily: 'Kanit', fontSize: 16 }}
                dangerouslySetInnerHTML={{ __html: news.content }}
              />

            </Card>
          </main>
        </>
      )}
    </div>
  );
};

export default NewsDetailPage;
